import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const LAGOS_TZ = 'Africa/Lagos';

export function fmtDate(iso: string | null | undefined, pattern = 'PP'): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), pattern);
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso: string | null | undefined, pattern = 'PP p'): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), pattern);
  } catch {
    return iso;
  }
}

export function fmtLagos(iso: string | null | undefined, pattern = 'PP p zzz'): string {
  if (!iso) return '—';
  try {
    return formatInTimeZone(parseISO(iso), LAGOS_TZ, pattern);
  } catch {
    return iso;
  }
}

export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true });
  } catch {
    return iso;
  }
}

export function fmtDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return '—';
  const total = Math.max(0, Math.floor(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, '0')}s`;
  return `${s}s`;
}

export function todayLagosIso(): string {
  return formatInTimeZone(new Date(), LAGOS_TZ, 'yyyy-MM-dd');
}

export function thisMondayLagosIso(): string {
  const todayStr = todayLagosIso();
  const [y, m, d] = todayStr.split('-').map((p) => Number.parseInt(p, 10)) as [
    number,
    number,
    number,
  ];
  const dt = new Date(Date.UTC(y, m - 1, d));
  const js = dt.getUTCDay();
  const daysSinceMonday = (js + 6) % 7;
  dt.setUTCDate(dt.getUTCDate() - daysSinceMonday);
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
}

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/** Convert API dayOfWeek (0=Mon..6=Sun) to a human label. */
export function dayLabel(d: number): string {
  return DAY_LABELS[d] ?? `Day ${d}`;
}

/** Convert API dayOfWeek (0=Mon..6=Sun) to FullCalendar's weekday number (0=Sun..6=Sat). */
export function apiToFcDow(d: number): number {
  return (d + 1) % 7;
}

/** Convert FullCalendar weekday (0=Sun..6=Sat) back to API (0=Mon..6=Sun). */
export function fcToApiDow(d: number): number {
  return (d + 6) % 7;
}
